import { render } from "./ProductoMasVendido.vue?vue&type=template&id=6d22e746&scoped=true"
import script from "./ProductoMasVendido.vue?vue&type=script&lang=js"
export * from "./ProductoMasVendido.vue?vue&type=script&lang=js"

import "./ProductoMasVendido.vue?vue&type=style&index=0&id=6d22e746&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d22e746"]])

export default __exports__